/**
 * Customer Reviews V2 Slider Component
 */
(function() {
  'use strict';

  const whenVisible = window.theme?.whenVisible || ((element, callback) => callback(element));

  function parseAutoplayDelayMs(value, fallbackSeconds) {
    const parsedValue = parseFloat(value);
    if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
      return fallbackSeconds * 1000;
    }

    const normalizedSeconds = parsedValue > 10 ? parsedValue / 1000 : parsedValue;
    return normalizedSeconds * 1000;
  }

  function initReviewV2Sliders(container = document) {
    const sections = (container.classList && container.classList.contains('reviews-v2-section'))
      ? [container]
      : container.querySelectorAll('.reviews-v2-section');

    sections.forEach(function(section) {
      const swiperElement = section.querySelector('.swiper');
      if (!swiperElement || section.swiper) return;

      window.loadThemeSwiper().then(() => {
        initSwiper(section, swiperElement);
      }).catch((error) => {
        console.warn('Swiper failed to load for CustomerReviewsV2:', error);
      });
    });
  }

  function initSwiper(section, swiperElement) {
    const originalSlideCount = section.originalSlideCount || swiperElement.querySelectorAll('.swiper-slide').length;
    section.originalSlideCount = originalSlideCount;

    const navPrev = section.querySelector('.reviews-v2-section__nav-btn--prev');
    const navNext = section.querySelector('.reviews-v2-section__nav-btn--next');
    const paginationEl = section.querySelector('.swiper-pagination');

    const slidesDesktop = parseInt(section.dataset.slidesDesktop, 10) || 3;
    const slidesTablet = parseInt(section.dataset.slidesTablet, 10) || 2;
    const slidesMobile = parseInt(section.dataset.slidesMobile, 10) || 1;
    const spaceBetween = parseInt(section.dataset.spaceBetween, 10) || 30;
    const spaceBetweenMobile = parseInt(section.dataset.spaceBetweenMobile, 10) || 20;
    const speed = parseInt(section.dataset.speed, 10) || 300;
    const showNavigation = section.dataset.showNavigation === 'true';
    const showPagination = section.dataset.showPagination === 'true';
    const loopEnabled = section.dataset.loop !== 'false';
    const loop = loopEnabled && originalSlideCount > Math.max(slidesDesktop, slidesTablet, slidesMobile);
    const autoplayEnabled = section.dataset.autoplay === 'true';
    const autoplay = autoplayEnabled
      ? {
          delay: parseAutoplayDelayMs(section.dataset.autoplayDelay, 4),
          disableOnInteraction: false,
          pauseOnMouseEnter: section.dataset.autoplayPauseOnHover !== 'false'
        }
      : false;

    section.swiper = new Swiper(swiperElement, {
      slidesPerView: slidesDesktop,
      spaceBetween: spaceBetween,
      loop: loop,
      speed: speed,
      watchOverflow: true,
      navigation: showNavigation && navPrev && navNext
        ? {
            nextEl: navNext,
            prevEl: navPrev
          }
        : false,
      pagination: showPagination && paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : false,
      autoplay: autoplay,
      breakpoints: {
        0: {
          slidesPerView: slidesMobile,
          spaceBetween: spaceBetweenMobile
        },
        576: {
          slidesPerView: slidesTablet,
          spaceBetween: spaceBetween
        },
        992: {
          slidesPerView: slidesDesktop,
          spaceBetween: spaceBetween
        }
      },
      on: {
        init() {
          syncNavigationAvailability(section);
        },
        resize() {
          syncNavigationAvailability(section);
        },
        breakpoint() {
          syncNavigationAvailability(section);
        },
        lock() {
          syncNavigationAvailability(section);
        },
        unlock() {
          syncNavigationAvailability(section);
        }
      }
    });

    syncNavigationAvailability(section);
  }

  function syncNavigationAvailability(section) {
    const swiper = section.swiper;
    const navPrev = section.querySelector('.reviews-v2-section__nav-btn--prev');
    const navNext = section.querySelector('.reviews-v2-section__nav-btn--next');
    const showNavigation = section.dataset.showNavigation === 'true';

    if (!swiper || !navPrev || !navNext || !showNavigation) {
      section.classList.remove('reviews-v2-section--can-navigate');
      return;
    }

    const currentSlidesPerView = getCurrentSlidesPerView(swiper);
    const originalSlideCount = section.originalSlideCount || 0;
    const hasOverflow = originalSlideCount > currentSlidesPerView;

    section.classList.toggle('reviews-v2-section--can-navigate', hasOverflow);
  }

  function getCurrentSlidesPerView(swiper) {
    const slidesPerView = swiper?.params?.slidesPerView;
    const numericSlidesPerView = typeof slidesPerView === 'number'
      ? slidesPerView
      : parseFloat(slidesPerView);

    return Number.isFinite(numericSlidesPerView) && numericSlidesPerView > 0
      ? numericSlidesPerView
      : 1;
  }

  if (!customElements.get('customer-reviews-v2-section')) {
    class CustomerReviewsV2Section extends HTMLElement {
      connectedCallback() {
        this.visibilityObserver = whenVisible(this, () => initReviewV2Sliders(this));
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect?.();
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }
    }

    customElements.define('customer-reviews-v2-section', CustomerReviewsV2Section);
  }
})();
